/* import __COLOCATED_TEMPLATE__ from './empty-state.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
